export default "__VITE_PUBLIC_ASSET__bf8e78ac__"